module.exports = __webpack_public_path__ + "media/images/back-arrow-5334694ef6cada7a03691869356a2369.svg";